angular
  .module('app', [
    'app.core'
  ]);